import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { TRUCK_SHIFT_UPDATE_MUTATION_KEY } from 'src/hooks/useIsTruckShiftUpdating';
import { BulkConflict, BulkRemoveRequestBody, parseCheckConflict } from 'src/pages/TruckShifts/bulkSelection';

export const BULK_REMOVE_PATH = '/api/v5/truck_shifts/bulk_removal';
export const BULK_REMOVE_CHECK_PATH = `${BULK_REMOVE_PATH}/check`;

// 解除前の衝突チェック（200・mutation なし）。衝突があれば BulkConflict、無ければ null。
export const checkBulkRemoveConflict = async (body: BulkRemoveRequestBody): Promise<BulkConflict | null> => {
  const response = await axios.post(BULK_REMOVE_CHECK_PATH, body);
  return parseCheckConflict(response.data);
};

export type BulkRemoveResult = { deleted_count: number; split_count?: number };

export const useMutationBulkRemove = () => useMutation({
  mutationFn: async (body: BulkRemoveRequestBody): Promise<BulkRemoveResult> => {
    const response = await axios.post<BulkRemoveResult>(BULK_REMOVE_PATH, body);
    return response.data;
  },
  // 稼働表更新として識別する mutationKey（右下「稼働表を更新中」＋編集ロックが働く）。
  // 成功時の invalidate は App の MutationCache にこの key で集約（画面 unmount 後の完了でも再取得するため）。
  mutationKey: TRUCK_SHIFT_UPDATE_MUTATION_KEY,
});
